import { BrandMark } from "@/components/wizard/brand-mark";
import { ChoiceButton, WizardInput, WizardOk, WizardStep } from "@/components/wizard/wizard-step";
import { pretensaoLabel, pretensaoOrder } from "@/lib/labels/lead-instagram";

import type { FieldKind } from "../../-utils/fields";
import type { InstagramWizard } from "../../-utils/wizard";

function inputMode(kind: FieldKind) {
	if (kind === "number") {
		return "numeric";
	}

	if (kind === "tel") {
		return "tel";
	}

	return "text";
}

export function FormStep({ wizard }: { wizard: InstagramWizard }) {
	const { step, fields, field, value, error, inputRef, draft, actions } = wizard;

	return (
		<WizardStep
			step={step}
			total={fields.length}
			label={field.label}
			hint={field.hint}
			error={error}
			onBack={actions.back}
			brand={<BrandMark />}
			footer={
				field.kind !== "chips" && (
					<div className="mt-8 flex items-center gap-3">
						<WizardOk onClick={actions.advance} />

						{!!field.optional && (
							<button
								type="button"
								onClick={actions.skip}
								className="flex items-center gap-2 rounded-full bg-secondary px-8 py-3 text-lg font-semibold text-secondary-foreground hover:bg-secondary/80"
							>
								Pular
							</button>
						)}
					</div>
				)
			}
		>
			{field.kind === "chips" && (
				<div className="flex flex-col gap-3">
					{pretensaoOrder.map((option) => (
						<ChoiceButton
							key={option}
							active={draft.pretensao === option}
							onClick={() => actions.choose(option)}
						>
							{pretensaoLabel[option]}
						</ChoiceButton>
					))}
				</div>
			)}

			{field.kind !== "chips" && (
				<WizardInput
					inputRef={inputRef}
					value={value}
					inputMode={inputMode(field.kind)}
					onChange={actions.set}
					onEnter={actions.advance}
				/>
			)}
		</WizardStep>
	);
}
